module.exports = __webpack_public_path__ + "img/multimodal.56012898.png";